module.exports = __webpack_public_path__ + "img/linkedin.66bec040.svg";